import { Card, Colors, DATE_FORMATS, formatDate, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import i18n from '@/plugins/i18n';

interface DraftSavedIndicatorProps {
    lastSavedAt: Date | null;
}

export const DraftSavedIndicator = ({ lastSavedAt }: DraftSavedIndicatorProps) => {
    const { t } = useAmelioTranslations();

    if (!lastSavedAt) {
        return null;
    }
    return (
        <Card className={'flex items-center rounded-lg bg-white px-4 shadow-sm lg:py-3'}>
            <Text
                className={'text-caption font-medium'}
                color={Colors.TEXT_GRAY}
            >
                {t('common.draftSavedAt', {
                    time: formatDate({
                        date: lastSavedAt,
                        language: i18n.language,
                        format: DATE_FORMATS.DISPLAY_DATE_TIME,
                    }),
                })}
            </Text>
        </Card>
    );
};
